export type InvalidSessionReason = 'account_deleted' | 'session_invalid';

type Handler = (reason: InvalidSessionReason) => void;

let handler: Handler | null = null;

// Module-level bus so `query-client` (instantiated before the React tree) and
// Realtime subscription callbacks can signal `AuthContext` to force a sign-out
// without participating in the React context.
export const authEvents = {
  setHandler(h: Handler | null) {
    handler = h;
  },
  emitInvalidSession(reason: InvalidSessionReason) {
    handler?.(reason);
  },
};
